import { useEffect } from 'react';
import { useEmployer } from '../context/EmployerContext';

/* EMP-07 — "View their own group's employee/enrolment overview."
   BrandonUserStoryAPI.md EMP-07: same endpoint ICIB-15 documents
   (GET /companies/{company_id}/overview), scoped server-side to a group this
   employer_admin is assigned to. Four headline counts, no drill-down of
   its own — EmployeesView/OutstandingView/LeaversView already cover the
   per-person detail this landing page just summarises. */
function OverviewView() {
  const {
    status, groupId, curGroup, groupOverview, groupOverviewStatus, groupOverviewError, loadGroupOverview,
  } = useEmployer();

  useEffect(() => { loadGroupOverview(groupId); }, [groupId, loadGroupOverview]);

  if (status === 'loading') return <div className="card"><div className="empty"><b>Loading…</b></div></div>;

  const overview = groupId ? groupOverview[groupId] : null;
  const overviewLoading = groupId && groupOverviewStatus === 'loading' && !overview;
  const totalEmployees = overview?.total_employees ?? 0;
  const onboarded = overview?.fully_onboarded_employees ?? 0;
  const invited = overview?.employees_with_invited_enrolment ?? 0;
  const removedCount = overview?.employees_with_removed_enrolment ?? 0;

  return (
    <>
      <div className="eyebrow">Overview</div>
      <div className="page-h"><h2>{curGroup()?.name || 'Your scheme'}</h2></div>
      <p className="page-sub">How your employee benefits scheme currently stands — who's on the register, who's fully covered, and who still needs action.</p>

      {groupOverviewError && <div className="note bad" style={{ marginBottom: 14 }}><b>Couldn't load the overview</b>{groupOverviewError}</div>}

      {!groupId ? (
        <div className="card"><div className="empty"><b>No company assigned</b>Your account isn't currently assigned to a company.</div></div>
      ) : (
        <>
          <div className="sec-h">
            <span className="spacer"></span>
            <span className="ep">GET /companies/{'{company_id}'}/overview</span>
          </div>
          <div className="grid g4">
            <div className="card stat"><div className="n">{overviewLoading ? '—' : totalEmployees}</div><div className="l">Total employee in the company</div></div>
            <div className="card stat"><div className="n">{overviewLoading ? '—' : onboarded}</div><div className="l">Employee Enrolled</div></div>
            <div className="card stat warn"><div className="n">{overviewLoading ? '—' : invited}</div><div className="l">Awaiting enrolment</div></div>
            <div className="card stat warn"><div className="n">{overviewLoading ? '—' : removedCount}</div><div className="l">Removals unconfirmed</div></div>
          </div>
        </>
      )}
    </>
  );
}

export default OverviewView;
